export const countries = [
    { "ISO": "US", "Name": "United States" },
    { "ISO": "GB", "Name": "United Kingdom" },
    { "ISO": "CA", "Name": "Canada" },
];

export const states = {
    "US": [
        {
            "Name": "Alabama",
            "ISO": "AL"
        },
        {
            "Name": "Alaska",
            "ISO": "AK"
        },
        {
            "Name": "American Samoa",
            "ISO": "AS"
        },
        {
            "Name": "Arizona",
            "ISO": "AZ"
        },
        {
            "Name": "Arkansas",
            "ISO": "AR"
        },
        {
            "Name": "California",
            "ISO": "CA"
        },
        {
            "Name": "Colorado",
            "ISO": "CO"
        },
        {
            "Name": "Connecticut",
            "ISO": "CT"
        },
        {
            "Name": "Delaware",
            "ISO": "DE"
        },
        {
            "Name": "District Of Columbia",
            "ISO": "DC"
        },
        {
            "Name": "Federated States Of Micronesia",
            "ISO": "FM"
        },
        {
            "Name": "Florida",
            "ISO": "FL"
        },
        {
            "Name": "Georgia",
            "ISO": "GA"
        },
        {
            "Name": "Guam",
            "ISO": "GU"
        },
        {
            "Name": "Hawaii",
            "ISO": "HI"
        },
        {
            "Name": "Idaho",
            "ISO": "ID"
        },
        {
            "Name": "Illinois",
            "ISO": "IL"
        },
        {
            "Name": "Indiana",
            "ISO": "IN"
        },
        {
            "Name": "Iowa",
            "ISO": "IA"
        },
        {
            "Name": "Kansas",
            "ISO": "KS"
        },
        {
            "Name": "Kentucky",
            "ISO": "KY"
        },
        {
            "Name": "Louisiana",
            "ISO": "LA"
        },
        {
            "Name": "Maine",
            "ISO": "ME"
        },
        {
            "Name": "Marshall Islands",
            "ISO": "MH"
        },
        {
            "Name": "Maryland",
            "ISO": "MD"
        },
        {
            "Name": "Massachusetts",
            "ISO": "MA"
        },
        {
            "Name": "Michigan",
            "ISO": "MI"
        },
        {
            "Name": "Minnesota",
            "ISO": "MN"
        },
        {
            "Name": "Mississippi",
            "ISO": "MS"
        },
        {
            "Name": "Missouri",
            "ISO": "MO"
        },
        {
            "Name": "Montana",
            "ISO": "MT"
        },
        {
            "Name": "Nebraska",
            "ISO": "NE"
        },
        {
            "Name": "Nevada",
            "ISO": "NV"
        },
        {
            "Name": "New Hampshire",
            "ISO": "NH"
        },
        {
            "Name": "New Jersey",
            "ISO": "NJ"
        },
        {
            "Name": "New Mexico",
            "ISO": "NM"
        },
        {
            "Name": "New York",
            "ISO": "NY"
        },
        {
            "Name": "North Carolina",
            "ISO": "NC"
        },
        {
            "Name": "North Dakota",
            "ISO": "ND"
        },
        {
            "Name": "Northern Mariana Islands",
            "ISO": "MP"
        },
        {
            "Name": "Ohio",
            "ISO": "OH"
        },
        {
            "Name": "Oklahoma",
            "ISO": "OK"
        },
        {
            "Name": "Oregon",
            "ISO": "OR"
        },
        {
            "Name": "Palau",
            "ISO": "PW"
        },
        {
            "Name": "Pennsylvania",
            "ISO": "PA"
        },
        {
            "Name": "Puerto Rico",
            "ISO": "PR"
        },
        {
            "Name": "Rhode Island",
            "ISO": "RI"
        },
        {
            "Name": "South Carolina",
            "ISO": "SC"
        },
        {
            "Name": "South Dakota",
            "ISO": "SD"
        },
        {
            "Name": "Tennessee",
            "ISO": "TN"
        },
        {
            "Name": "Texas",
            "ISO": "TX"
        },
        {
            "Name": "Utah",
            "ISO": "UT"
        },
        {
            "Name": "Vermont",
            "ISO": "VT"
        },
        {
            "Name": "Virgin Islands",
            "ISO": "VI"
        },
        {
            "Name": "Virginia",
            "ISO": "VA"
        },
        {
            "Name": "Washington",
            "ISO": "WA"
        },
        {
            "Name": "West Virginia",
            "ISO": "WV"
        },
        {
            "Name": "Wisconsin",
            "ISO": "WI"
        },
        {
            "Name": "Wyoming",
            "ISO": "WY"
        }
    ],
    "GB": [],
    "CA": [
        {
            "Name": "Alberta",
            "ISO": "AB"
        },
        {
            "Name": "British Columbia",
            "ISO": "BC"
        },
        {
            "Name": "Manitoba",
            "ISO": "MB"
        },
        {
            "Name": "New Brunswick",
            "ISO": "NB"
        },
        {
            "Name": "Newfoundland and Labrador",
            "ISO": "NL"
        },
        {
            "Name": "Northwest Territories",
            "ISO": "NT"
        },
        {
            "Name": "Nova Scotia",
            "ISO": "NS"
        },
        {
            "Name": "Nunavut",
            "ISO": "NU"
        },
        {
            "Name": "Ontario",
            "ISO": "ON"
        },
        {
            "Name": "Prince Edward Island",
            "ISO": "PE"
        },
        {
            "Name": "Quebec",
            "ISO": "QC"
        },
        {
            "Name": "Saskatchewan",
            "ISO": "SK"
        },
        {
            "Name": "Yukon Territory",
            "ISO": "YT"
        }
    ]
}
